import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getUsers } from '../../../../core/actions/allUsers';
import { Table, Icon, Button, Tag, Row } from 'antd';
import { Link  } from 'react-router-dom'

export class UserManagement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      users: [],
      columns: [
        // {
        //   title: 'USER ID',
        //   dataIndex: 'id',
        //   key: 'id'
        // },
        {
          title: 'FULLNAME',
          dataIndex: 'fullName',
          key: 'fullName',
        }, 
        {
          title: 'PLAN',
          dataIndex: 'plan',
          key: 'plan',
          render: (text, record) => (
            <span>
              { record.plan ?
              <Tag color="blue" className="tag">{record.plan}</Tag>
              : null }
            </span>
          )
        }, 
        {
          title: 'ROLE',
          dataIndex: 'role',
          key: 'role',
          render: (text, record) => (
            <span>
              { record.role ?
              <Tag color="blue" className="tag">{record.role}</Tag>
              : null }
            </span>
          )
        },
        {
          title: 'ACTION',
          key: 'action',
          render: (text, record) => (
            <span>
              <Button type="primary" size="small"><Link to={`/manageuser/${record.key}`}> Manage <Icon type="edit" /></Link></Button>
            </span>
          )
        }
      ]
    }

    this.gotoUser = this.gotoUser.bind(this)
    this.restructureUsers = this.restructureUsers.bind(this)
  }

  componentDidMount() {
    const { users } = this.state;
    if (!users.length) {
      this.props.getUsers();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { users } = nextProps;
    if (users.length > 0) {
      // this.setState({ users })
      this.restructureUsers(users)
    }
  }

  gotoUser(id) {
    this.props.history.push(`/settings/manageuser/${id}`);
  }

  restructureUsers(users) {
    let newUSers = []
    users.forEach(element => {
      newUSers.push(Object.assign(element, {key: element.id}))
    });
    this.setState({
      users: newUSers
    })
  }

  render() {
    const { users, columns } = this.state
    return (
      <div className="user-mgt">
        <Row>
          <Table dataSource={users} columns={columns} scroll={{ y: 400 }}/>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.allUsers.users
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getUsers
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement)
